import React from 'react';
import { PageHero } from '../components/PageHero';
import { Breadcrumbs } from '../components/Breadcrumbs';
import { PartnerCTA } from '../components/PartnerCTA';
export function PrivacyPolicyPage() {
  return <>
      <PageHero title="Privacy Policy" data-id="element-1102" />

      <Breadcrumbs items={[{
      label: 'Privacy Policy'
    }]} data-id="element-1103" />

      <section className="bg-white py-24" data-id="element-1104">
        <div className="max-w-3xl mx-auto px-6 lg:px-8 prose prose-lg text-steel-600" data-id="element-1105">
          <p data-id="element-1106">Last updated: February 2025</p>
          <p data-id="element-1107">
            Chiltern Global Ltd ("we", "us", or "our") is committed to
            protecting and respecting your privacy. This policy sets out the
            basis on which any personal data we collect from you, or that you
            provide to us, will be processed by us.
          </p>
          <h3 data-id="element-1108">Information We Collect</h3>
          <p data-id="element-1109">We may collect and process the following data about you:</p>
          <ul data-id="element-1110">
            <li data-id="element-1111">
              Information you give us by filling in forms on our site (e.g.
              contact forms, catalogue requests).
            </li>
            <li data-id="element-1112">
              If you contact us, we may keep a record of that correspondence.
            </li>
            <li data-id="element-1113">
              Details of your visits to our site and the resources that you
              access.
            </li>
          </ul>
          <h3 data-id="element-1114">How We Use Your Information</h3>
          <p data-id="element-1115">We use information held about you in the following ways:</p>
          <ul data-id="element-1116">
            <li data-id="element-1117">
              To ensure that content from our site is presented in the most
              effective manner for you and for your computer.
            </li>
            <li data-id="element-1118">
              To provide you with information, products or services that you
              request from us.
            </li>
            <li data-id="element-1119">
              To carry out our obligations arising from any contracts entered
              into between you and us.
            </li>
          </ul>
          <h3 data-id="element-1120">Data Security</h3>
          <p data-id="element-1121">
            We take appropriate measures to ensure that your data is treated
            securely and in accordance with this privacy policy. Unfortunately,
            the transmission of information via the internet is not completely
            secure. Although we will do our best to protect your personal data,
            we cannot guarantee the security of your data transmitted to our
            site.
          </p>
          <h3 data-id="element-1122">Contact</h3>
          <p data-id="element-1123">
            Questions, comments and requests regarding this privacy policy are
            welcomed and should be addressed to enquiries@chilternglobal.com.
          </p>
        </div>
      </section>

      <PartnerCTA data-id="element-1124" />
    </>;
}